/**
 * PracticeSignature — a signature editorial still-life hero for a practice
 * area page. Sepia photograph on the left, caption + credit rule on the
 * right. Ivory background, restrained.
 */
export default function PracticeSignature({ src, caption, kicker = "A Signature Detail", ratio = "3 / 2" }) {
  return (
    <section className="bg-ivory hairline-bottom" data-testid="practice-signature">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
        <figure
          className="md:col-span-7 relative overflow-hidden"
          style={{ aspectRatio: ratio }}
        >
          <img
            src={src}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover"
            style={{ filter: "sepia(0.18) contrast(1.02)" }}
            data-testid="practice-signature-image"
          />
        </figure>
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-brass" />
            <span className="text-[10px] uppercase tracking-[0.32em] text-brass font-medium">
              {kicker}
            </span>
          </div>
          <p
            className="font-cormorant italic text-slate2 text-2xl md:text-3xl leading-snug"
            data-testid="practice-signature-caption"
          >
            {caption}
          </p>
        </div>
      </div>
    </section>
  );
}
